"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var detect_node_1 = require("detect-node");
exports.env = {
    isNode: detect_node_1.default,
    forceCache: false,
};



//////////////////
// WEBPACK FOOTER
// ./~/use-sidecar/dist/es5/env.js
// module id = 2241
// module chunks = 0